package com.pincer.app

import com.pincer.core.Logger
import com.pincer.core.DEFAULT_LOCALE
import com.pincer.core.DEFAULT_ZONE
import com.pincer.client.DEFAULT_SERVER_URL
import com.pincer.client.DEFAULT_WEBSOCKET_URL
import com.pincer.core.functions.validateServerUrl
import com.pincer.core.functions.validateWebSocketUrl
import com.russhwolf.settings.Settings
import com.russhwolf.settings.string
import com.russhwolf.settings.nullableString

/*
Simple application state fields that survive restarts.
We use russhwolf settings to do this in a multiplatform way.
The settings store is a parameter so tests and the MCP server can keep theirs apart from the developer's REPL.
*/
class StoredState(private val log: Logger, private val settings: Settings = Settings()) {
    private val keyPrefix = "pincer.app"
    //private fun string(key: String, default: String) = settings.string("$keyPrefix.$key", default)
    //private fun nullableString(key: String) = settings.nullableString("$keyPrefix.$key")

    var deviceId                by settings.nullableString("$keyPrefix.device.id")
    var deviceSecret            by settings.nullableString("$keyPrefix.secret")
    var fallbackLocale          by settings.string("$keyPrefix.fallback.locale",    DEFAULT_LOCALE)
    var fallbackZone            by settings.string("$keyPrefix.fallback.zone",      DEFAULT_ZONE)
    var showAdvancedOptions     by settings.string("$keyPrefix.advanced.options",   "false")
    var serverUrl               by settings.string("$keyPrefix.server.url",         DEFAULT_SERVER_URL)
    var webSocketUrl            by settings.string("$keyPrefix.websocket.url",      DEFAULT_WEBSOCKET_URL)

    fun deviceSecretHidden() = (deviceSecret?.substring(0,14) ?: "not set ") + "********"
    fun showAdvancedOptionsAsBoolean() = showAdvancedOptions == "true"

    fun logAll() {
        log.i("StoredState contents...")
        log.i("           deviceId: $deviceId")
        log.i("       deviceSecret: ${deviceSecretHidden()}")
        log.i("     fallbackLocale: $fallbackLocale")
        log.i("       fallbackZone: $fallbackZone")
        log.i("showAdvancedOptions: $showAdvancedOptions")
        log.i("          serverUrl: $serverUrl")
        log.i("       webSocketUrl: $webSocketUrl")
    }

    fun clear() = settings.clear()

}
